import { memo } from 'react';
import parser from 'html-react-parser';
import createDOMPurify from 'dompurify';
import renderers from './Renderers';

const DOMPurify = createDOMPurify(window);

const getRenderer = (node) => (renderers[node.type] ? renderers[node.type][node.name] || (() => node) : (() => node));

const HtmlRenderer = ({ render }) => {
  try {
    const sanitizedHtml = DOMPurify.sanitize(render, {
      USE_PROFILES: { html: true }
    });

    const options = { replace: (node) => getRenderer(node)({ ...node, options }) };

    return parser(sanitizedHtml, options);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);

    return null;
  }
};

export default memo(HtmlRenderer);
